import { TApplicationState } from 'shared/types/redux';
import { hasValidPhone } from 'shared/utils/agent';

export const buildersSelector = (state: TApplicationState) => {
  return state.newbuilding.builders;
};

export function buildersWithPhonesSelector(state: TApplicationState) {
  const {
    newbuilding: { builders },
  } = state;

  if (builders) {
    return builders.filter(builder => builder.showPhone && builder.phone);
  }

  return [];
}

export function buildersWithValidPhonesSelector(state: TApplicationState) {
  const builders = buildersSelector(state);

  return builders.filter(hasValidPhone);
}
